module.exports = __webpack_public_path__ + "static/ComfortCottage8bitcopy-dc061eb3877a33eeb56dacc8b1b0e22d.png";